<div class="grid no-gutters">
  <div class="col-11 flex flex-row">
    <p-checkbox [inputId]="filterModel.filterDto.id.toString()" [(ngModel)]="filterModel.enabled"
                [disabled]="filterModel.readonly"
                [readonly]=filterModel.filterDto.readonly
                [binary]="true"
                (onChange)="includeFilters($event); excludeFilters($event); checkIfUpdateMap(filterModel.filterDto.name)"
                [ngClass]="{'readonly-filter-checkbox': filterModel.filterDto.readonly}"
    ></p-checkbox>
    <label class="pl-2" [for]="filterModel.filterDto.id"> 
      {{filterModel.filterDto.description}}
    </label>
  </div>
  <div [ngClass]="{'col-1': true, 'adjust-margin': isIncluded}">
    <span class="pi pi-question-circle" [pTooltip]="filterModel.filterDto.help_text"></span>
  </div>
</div>
